var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "retrospective" },
    [
      _c(
        "div",
        {
          staticClass: "retrospective__title",
          style: {
            fontSize: _vm.titleFontSize,
            lineHeight: _vm.titleLineHeight
          }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.sectionTitle
                  ? _vm.sectionTitle
                  : _vm.$t("subscriptions.retrospective.title")
              ) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "retrospective__content" }, [
        _c("div", { staticClass: "image-container" }, [
          _c("div", { staticClass: "image image-before" }, [
            _c("img", {
              attrs: {
                src: _vm.mediaBaseUrl + "subscriptions/before-image.png"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "image image-after" }, [
            _c("img", {
              attrs: { src: _vm.mediaBaseUrl + "subscriptions/after-image.png" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bullet" }, [
            _c("div", { staticClass: "bullet__text" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("subscriptions.retrospective.bulletText")) +
                  "\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("subscriptions.retrospective.text")) +
              "\n    "
          )
        ])
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }